// app/javascript/public_marketing.js
// Centralized event delegation and interactivity for Doccu Public Marketing & Auth Shell (WO-009)
// Complies strictly with Content Security Policy (zero inline scripts, zero inline handlers)

let supportDebounceTimer = null
let currentSupportFilter = 'all'

function openMobileMenu () {
  const toggle = document.getElementById('menu-toggle')
  const drawer = document.getElementById('mobile-menu-drawer')
  const backdrop = document.getElementById('mobile-menu-backdrop')
  if (!drawer || !backdrop) return

  drawer.classList.remove('-translate-x-full')
  drawer.classList.add('translate-x-0')
  backdrop.classList.remove('opacity-0', 'pointer-events-none')
  backdrop.classList.add('opacity-100', 'pointer-events-auto')
  drawer.setAttribute('aria-hidden', 'false')
  backdrop.setAttribute('aria-hidden', 'false')
  document.body.style.overflow = 'hidden'

  if (toggle) {
    toggle.setAttribute('aria-expanded', 'true')
    toggle.classList.add('menu-open')
  }
}

function closeMobileMenu () {
  const toggle = document.getElementById('menu-toggle')
  const drawer = document.getElementById('mobile-menu-drawer')
  const backdrop = document.getElementById('mobile-menu-backdrop')
  if (!drawer || !backdrop) return

  drawer.classList.remove('translate-x-0')
  drawer.classList.add('-translate-x-full')
  backdrop.classList.remove('opacity-100', 'pointer-events-auto')
  backdrop.classList.add('opacity-0', 'pointer-events-none')
  drawer.setAttribute('aria-hidden', 'true')
  backdrop.setAttribute('aria-hidden', 'true')
  document.body.style.overflow = ''

  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false')
    toggle.classList.remove('menu-open')
  }
}

function applySupportFilterAndSearch () {
  const searchInput = document.getElementById('support-search-input')
  const clearBtn = document.getElementById('support-search-clear')
  const topicsSection = document.getElementById('support-topics-section')
  const videosSection = document.getElementById('support-videos-section')
  const faqsSection = document.getElementById('support-faqs-section')
  const emptyState = document.getElementById('support-empty-state')
  const resultsCount = document.getElementById('results-count')

  const query = (searchInput?.value || '').toLowerCase().trim()
  if (clearBtn) {
    if (query) {
      clearBtn.classList.remove('hidden')
    } else {
      clearBtn.classList.add('hidden')
    }
  }

  let visibleFaqs = 0
  let visibleVideos = 0
  let visibleTopics = 0

  // Filter FAQs
  document.querySelectorAll('.faq-item').forEach((item) => {
    const text = (item.textContent || '').toLowerCase()
    const matchesQuery = !query || text.includes(query)
    const matchesFilter = currentSupportFilter === 'all' || currentSupportFilter === 'faqs'

    if (matchesQuery && matchesFilter) {
      item.classList.remove('hidden')
      visibleFaqs++
    } else {
      item.classList.add('hidden')
    }
  })

  // Filter Videos
  document.querySelectorAll('.video-card').forEach((item) => {
    const text = (item.textContent || '').toLowerCase()
    const matchesQuery = !query || text.includes(query)
    const matchesFilter = currentSupportFilter === 'all' || currentSupportFilter === 'videos'

    if (matchesQuery && matchesFilter) {
      item.classList.remove('hidden')
      visibleVideos++
    } else {
      item.classList.add('hidden')
    }
  })

  // Filter Topics
  document.querySelectorAll('.topic-card').forEach((item) => {
    const text = (item.textContent || '').toLowerCase()
    const matchesQuery = !query || text.includes(query)
    const matchesFilter = currentSupportFilter === 'all' || currentSupportFilter === 'guides'

    if (matchesQuery && matchesFilter) {
      item.classList.remove('hidden')
      visibleTopics++
    } else {
      item.classList.add('hidden')
    }
  })

  // Section visibility
  if (topicsSection) {
    topicsSection.style.display = (visibleTopics > 0 && (currentSupportFilter === 'all' || currentSupportFilter === 'guides')) ? 'flex' : 'none'
  }
  if (videosSection) {
    videosSection.style.display = (visibleVideos > 0 && (currentSupportFilter === 'all' || currentSupportFilter === 'videos')) ? 'flex' : 'none'
  }
  if (faqsSection) {
    faqsSection.style.display = (visibleFaqs > 0 && (currentSupportFilter === 'all' || currentSupportFilter === 'faqs')) ? 'flex' : 'none'
  }

  const total = visibleFaqs + visibleVideos + visibleTopics
  if (resultsCount) {
    resultsCount.textContent = total
  }
  if (emptyState) {
    emptyState.classList.toggle('hidden', total > 0)
  }
}

function refreshRecaptchaToken () {
  if (typeof window.grecaptcha !== 'undefined') {
    window.grecaptcha.ready(() => {
      const siteKey = window.doccuRecaptchaSiteKey || document.querySelector('meta[name="recaptcha-site-key"]')?.content
      const input = document.getElementById('g-recaptcha-response-data-login')
      if (input && siteKey) {
        window.grecaptcha.execute(siteKey, { action: 'login' }).then((token) => {
          input.value = token
        }).catch(() => {})
      }
    })
  }
}

function setupPublicMarketingDelegation () {
  // Document-level Click Delegation
  document.addEventListener('click', (event) => {
    // 1. Mobile Menu Toggle Button
    const menuToggle = event.target.closest('#menu-toggle, [data-public-nav-action="toggle-menu"]')
    if (menuToggle) {
      event.preventDefault()
      event.stopPropagation()
      const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true'
      if (isExpanded) {
        closeMobileMenu()
      } else {
        openMobileMenu()
      }
      return
    }

    // 2. Mobile Menu Close Button
    const menuClose = event.target.closest('#menu-drawer-close, [data-public-nav-action="close-menu"]')
    if (menuClose) {
      event.preventDefault()
      event.stopPropagation()
      closeMobileMenu()
      return
    }

    // 3. Mobile Menu Backdrop Click
    if (event.target.id === 'mobile-menu-backdrop') {
      event.preventDefault()
      event.stopPropagation()
      closeMobileMenu()
      return
    }

    // 4. Mobile Menu Link Click
    if (event.target.closest('#mobile-menu-drawer a')) {
      closeMobileMenu()
      return
    }

    // 5. Support Search Clear Button
    const searchClear = event.target.closest('#support-search-clear, [data-support-action="clear-search"]')
    if (searchClear) {
      event.preventDefault()
      const searchInput = document.getElementById('support-search-input')
      if (searchInput) {
        searchInput.value = ''
        applySupportFilterAndSearch()
        searchInput.focus()
      }
      return
    }

    // 6. Support Category Filter Pills
    const filterPill = event.target.closest('#support-filter-pills .filter-pill, [data-support-action="filter-category"]')
    if (filterPill) {
      event.preventDefault()
      const pills = document.querySelectorAll('#support-filter-pills .filter-pill, [data-support-action="filter-category"]')
      pills.forEach((p) => {
        p.classList.remove('bg-[#043f42]', 'text-white')
        p.classList.add('bg-white', 'border', 'border-[#e5e7eb]', 'text-black')
      })
      filterPill.classList.remove('bg-white', 'border', 'border-[#e5e7eb]', 'text-black')
      filterPill.classList.add('bg-[#043f42]', 'text-white')

      currentSupportFilter = filterPill.dataset.filter || 'all'
      applySupportFilterAndSearch()
      return
    }

    // 7. Video Player Controls Overlay Toggle
    const videoToggleBtn = event.target.closest('[data-action="toggle-video-controls"]')
    if (videoToggleBtn) {
      event.preventDefault()
      const videoCard = videoToggleBtn.closest('.video-card, [data-video-id]')
      if (videoCard) {
        const controls = videoCard.querySelector('.video-controls')
        if (controls) {
          controls.classList.toggle('hidden')
        }
      }
      return
    }

    // 8. Open Crisp Chat Direct Action
    const crispBtn = event.target.closest('[data-action="open-crisp-chat"]')
    if (crispBtn) {
      event.preventDefault()
      if (typeof window.doccuOpenCrispChat === 'function') {
        window.doccuOpenCrispChat()
      } else if (typeof window.$crisp !== 'undefined' && Array.isArray(window.$crisp)) {
        window.$crisp.push(['do', 'chat:open'])
      }
      return
    }

    // 9. Devise 2FA / Backup Recovery Code Toggle
    const backupCodeToggle = event.target.closest('#toggle_backup_code_btn, [data-auth-action="toggle-backup-code"]')
    if (backupCodeToggle) {
      event.preventDefault()
      const totpGroup = document.getElementById('totp_input_group')
      const backupGroup = document.getElementById('backup_code_input_group')
      const totpField = document.getElementById('otp_attempt_field')
      const backupField = document.getElementById('backup_code_field')

      if (totpGroup && backupGroup) {
        const isBackup = !backupGroup.classList.contains('hidden')
        if (isBackup) {
          // Switch back to TOTP
          backupGroup.classList.add('hidden')
          if (backupField) backupField.disabled = true
          totpGroup.classList.remove('hidden')
          if (totpField) {
            totpField.disabled = false
            totpField.focus()
          }
          backupCodeToggle.textContent = backupCodeToggle.dataset.totpLabel || 'Lost your authenticator device? Enter an emergency backup code'
        } else {
          // Switch to Backup Code
          totpGroup.classList.add('hidden')
          if (totpField) totpField.disabled = true
          backupGroup.classList.remove('hidden')
          if (backupField) {
            backupField.disabled = false
            backupField.focus()
          }
          backupCodeToggle.textContent = backupCodeToggle.dataset.backupLabel || 'Use 6-digit authenticator code instead'
        }
      }
    }
  })

  // Keyboard handler for Escape key (closes mobile menu)
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const toggle = document.getElementById('menu-toggle')
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        closeMobileMenu()
      }
    }
  })

  // Input event delegation for Support Search (250ms debounce)
  document.addEventListener('input', (event) => {
    if (event.target.id === 'support-search-input') {
      clearTimeout(supportDebounceTimer)
      supportDebounceTimer = setTimeout(applySupportFilterAndSearch, 250)
    }
  })

  // Turbo Navigation Handlers
  document.addEventListener('turbo:before-cache', () => {
    closeMobileMenu()
  })

  document.addEventListener('turbo:load', () => {
    closeMobileMenu()
    refreshRecaptchaToken()
  })

  document.addEventListener('turbo:render', () => {
    closeMobileMenu()
    refreshRecaptchaToken()
  })

  document.addEventListener('turbo:submit-end', () => {
    const loginInput = document.getElementById('g-recaptcha-response-data-login')
    if (loginInput) loginInput.value = ''
    refreshRecaptchaToken()
  })
}

// Initialize on script execution
setupPublicMarketingDelegation()
